import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon, FacebookIcon, LinkedinIcon, TwitterIcon } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-brand-navy text-white pt-20 pb-10" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="grid lg:grid-cols-4 gap-12 mb-16" data-id="element-41">
          <div className="col-span-1 lg:col-span-2" data-id="element-42">
            <Link to="/" data-id="element-43">
              <img src="https://cdn.magicpatterns.com/uploads/aWQSKdCC9bQ3YkJsWHEuVT/Global_Restorative3_(1).jpg" alt="Logo" className="h-20 w-auto mb-8 bg-white p-2 rounded-lg" data-id="element-44" />
            </Link>
            <p className="text-gray-400 max-w-md mb-8 leading-relaxed" data-id="element-45">
              Restoring Health. Renewing Minds. Rebuilding Lives. We are a
              trusted leader in integrated healthcare and mental wellness
              services locally, nationally, and globally.
            </p>
            <div className="flex space-x-4" data-id="element-46">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-47">
                <FacebookIcon className="h-5 w-5" data-id="element-48" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-49">
                <LinkedinIcon className="h-5 w-5" data-id="element-50" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-51">
                <TwitterIcon className="h-5 w-5" data-id="element-52" />
              </a>
            </div>
          </div>

          <div data-id="element-53">
            <h5 className="text-lg font-bold mb-6" data-id="element-54">Quick Links</h5>
            <ul className="space-y-4 text-gray-400" data-id="element-55">
              <li data-id="element-56">
                <Link to="/about" className="hover:text-white transition-colors" data-id="element-57">
                  About Us
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-59">
                  Our Services
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/leadership" className="hover:text-white transition-colors" data-id="element-61">
                  Leadership
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-63">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-64">
            <h5 className="text-lg font-bold mb-6" data-id="element-65">Contact Us</h5>
            <ul className="space-y-4 text-gray-400" data-id="element-66">
              <li className="flex items-start" data-id="element-67">
                <PhoneIcon className="h-5 w-5 text-brand-red mr-3 mt-1" data-id="element-68" />
                <span data-id="element-69">Contact us for scheduling</span>
              </li>
              <li className="flex items-start" data-id="element-70">
                <MailIcon className="h-5 w-5 text-brand-red mr-3 mt-1" data-id="element-71" />
                <span data-id="element-72">info@globalrestorative.com</span>
              </li>
              <li className="flex items-start" data-id="element-73">
                <MapPinIcon className="h-5 w-5 text-brand-red mr-3 mt-1" data-id="element-74" />
                <span data-id="element-75">Serving Locally, Nationally, and Globally</span>
              </li>
              <li className="pt-2" data-id="element-76">
                <Link to="/contact" className="text-brand-red font-bold hover:text-white transition-colors" data-id="element-77">
                  Get in Touch →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-78">
          <p data-id="element-79">
            © {new Date().getFullYear()} Global Restorative Health & Wellness
            LLC. All rights reserved.
          </p>
          <p data-id="element-80">Restoring Health. Renewing Minds. Rebuilding Lives.</p>
        </div>
      </div>
    </footer>;
}